import React, { useState, useRef } from 'react';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import Swal from 'sweetalert2';
import Navbar from '../components/Navbar/Navbar';
import Factory from '../components/Factory/Factory';

function Home({ user }) {
  const [refreshKey, setRefreshKey] = useState(0); // Para forzar un reset del estado.
  const userId = user?.uid;
  const factoryRef = useRef();

  const generatePDF = async () => {
    const pdf = new jsPDF('p', 'mm', 'a4');
    const margin = 7;
    const margin2 = 7;

    pdf.setDrawColor(0);
    pdf.setFillColor(255);
    pdf.rect(margin, margin2, pdf.internal.pageSize.getWidth() - 2 * margin, pdf.internal.pageSize.getHeight() - 2 * margin2, 'F');

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const factoryElement = factoryRef.current;

    if (!factoryElement) {
      Swal.fire({
        title: 'Error',
        text: 'No se encontró el contenido principal para generar el PDF.',
        icon: 'error',
        confirmButtonText: 'Aceptar',
      });
      return;
    }

    try {
      const sections = [
        '.equipment-table1, .equipment-table2, .quotation-title, .quotation-table',
        'h2, .equipment-table, .data-table',
        '.politicas-titulo, .politicas-texto',
      ];

      // Guardar los estilos originales para restaurarlos después
      const originalStyles = {
        fontFamily: factoryElement.style.fontFamily,
        fontSize: factoryElement.style.fontSize,
      };

      // Aplicar estilos temporales
      factoryElement.style.fontFamily = 'Arial, sans-serif';
      factoryElement.style.fontSize = '18px';

      const equipmentCells = factoryElement.querySelectorAll('td');
      equipmentCells.forEach(td => {
        if (td.querySelector('.button-container')) {
          td.innerHTML = '';  // Limpiar los botones para la generación del PDF
        }
      });

      let currentY = margin2;

      for (const selector of sections) {
        const elements = factoryElement.querySelectorAll(selector);
        if (elements.length === 0) continue;

        const sectionContainer = document.createElement('div');
        sectionContainer.style.position = 'absolute';
        sectionContainer.style.left = '-9999px';
        document.body.appendChild(sectionContainer);

        elements.forEach(el => {
          sectionContainer.appendChild(el.cloneNode(true));
        });

        const canvas = await html2canvas(sectionContainer, {
          scale: 1,
          useCORS: true,
        });

        const imgData = canvas.toDataURL('image/png');
        const imgHeight = (canvas.height * pdfWidth) / canvas.width;

        pdf.addImage(imgData, 'PNG', margin, currentY, pdfWidth - 2 * margin, imgHeight);
        currentY += imgHeight;

        const isLastSection = sections.indexOf(selector) === sections.length - 1;
        if (!isLastSection) {
          pdf.addPage();
          currentY = margin2;
        }

        document.body.removeChild(sectionContainer);
      }

      // Agregar la imagen con los márgenes y centrarla
      const imgElement = factoryElement.querySelector('.politicas-imagen img');
      if (imgElement) {
        const imgWidth = imgElement.naturalWidth;
        const imgHeight = imgElement.naturalHeight;

        const maxWidth = pdfWidth - 2 * margin;  // Ancho máximo permitido, con márgenes
        const scaleFactor = maxWidth / imgWidth;
        const newWidth = maxWidth;
        const newHeight = imgHeight * scaleFactor;

        // Calcular la posición X para centrar la imagen
        const centerX = (pdfWidth - newWidth) / 2;
        const imgYPosition = currentY + 10;  // Espacio de margen superior

        // Agregar la imagen al PDF
        pdf.addImage(imgElement.src, 'PNG', centerX, imgYPosition, newWidth, newHeight);
        currentY = imgYPosition + newHeight + 10;  // Actualizar la posición Y después de la imagen
      }


      const date = new Date();
      const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
      const fileName = `cotización-${formattedDate}.pdf`;

      pdf.save(fileName);

      // Restaurar los estilos originales
      factoryElement.style.fontFamily = originalStyles.fontFamily;
      factoryElement.style.fontSize = originalStyles.fontSize;

      // Forzar el re-render de la vista sin recargar la página
      setRefreshKey(prevKey => prevKey + 1);

      Swal.fire({
        title: '¡PDF Generado!',
        text: 'El archivo se ha guardado exitosamente.',
        confirmButtonText: 'Aceptar',
      });

    } catch (error) {
      console.error('Error al generar el PDF:', error);
      Swal.fire({
        title: 'Error',
        text: 'Ocurrió un problema al generar el PDF.',
        icon: 'error',
        confirmButtonText: 'Aceptar',
      });
    }
  };

  return (
    <div>
      <Navbar user={user} onPrint={generatePDF} />
      <div key={refreshKey}>
        <div ref={factoryRef}>
          <Factory user={user} userId={userId} />
        </div>
      </div>
    </div>
  );
}

export default Home;
